export * from './test.component'